/*
 * Copyright (c) 2018 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';

import { HttpService } from '@angular-kit/core';

import { Carryover, CarryoverData } from '@teamworks/global';


@Injectable()
export class CarryoverService {

  constructor(private httpService: HttpService) { }

  async loadCarryover(employeeId: string, year: string, month: string): Promise<Carryover> {
    return this.httpService.get(`api/time-recording/carryover/${employeeId}/${year}/${month}`)
      .then((loadedData: CarryoverData) => loadedData && new Carryover(loadedData));
  }

  async saveCarryover(employeeId: string, year: string, month: string, carryover: CarryoverData) {
    return this.httpService.post(`api/time-recording/carryover/${employeeId}/${year}/${month}`, carryover);
  }
}
